import React from "react";
import {useEffect, useState} from "react";
import BtnSecondary from "../../bootstrap/button/secondary/BtnSecondary";

const ModalCustomVH = ({
                           title,
                           titleLayout,
                           closeModal,
                           footerTemplate,
                           modalStyle,
                           children,
                           className,
                           size = 'xl',
                           isFullScreen = true
                       }: any) => {
    const [animation, setAnimation] = useState("");
    useEffect(() => {
        setTimeout(() => {
            setAnimation("in show");
            document.body.style.overflow = "hidden";
        }, 100);
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div
            className={`sh modal fade ${isFullScreen ? 'modal-vh' : ''} ${animation} ${className}`}
            tabIndex={-1}
            role="dialog"
            style={{display: "block", ...modalStyle}}>
            <div className={`modal-dialog modal-${size}`} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        {titleLayout ? (
                            titleLayout
                        ) : (
                            <h4 className="modal-title">{title}</h4>
                        )}
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">{children}</div>
                    </div>
                    <div className="modal-footer">
                        {footerTemplate ? (
                            footerTemplate
                        ) : (
                            <>
                                <BtnSecondary data-dismiss="modal" onClick={closeModal}>
                                    Chiudi
                                </BtnSecondary>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalCustomVH;
